/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../../assets/css/Navigation.css';
import LogoTriage from './LogoTriage';
import { invalidateMfaSession } from '../../MfaApi';

/* ===========================
CLASS
=========================== */
class Navigation extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.handleSignOut = this.handleSignOut.bind(this);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  async handleSignOut() {
    this.props.updateLoadingApp(true);
    try {
      const token = localStorage.accessToken;
      if (token) await invalidateMfaSession(token);
    } catch {
      // non-blocking
    }
    this.props.signOut();
    // Since no callback can be provided to signout, we use setTimeout to change the url
    setTimeout(() => {
      localStorage.removeItem('accessToken');
      window.location.pathname = '/login';
    }, 500);
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <Link to="/" className="navbar-brand">
          <LogoTriage />
        </Link>

        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav mr-auto">
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/canvases') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/canvases">Canvases</Link>
            </li>
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/bundles') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/bundles">Bundles</Link>
            </li>
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/firmwares') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/firmwares">Firmwares</Link>
            </li>
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/apks') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/apks">Apks</Link>
            </li>
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/histories') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/histories">Histories</Link>
            </li>
            <li className={`nav-item ${(window.location.href.indexOf('dashboard/rules') > -1) ? 'active' : ''}`}>
              <Link className="nav-link" to="/dashboard/rules">Rules</Link>
            </li>
          </ul>
        </div>

        <span className="navbar-text">
          <button onClick={this.handleSignOut} type="button" className="btn btn-primary">Sign Out</button>
        </span>
      </nav>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
Navigation.propTypes = {
  updateLoadingApp: PropTypes.func,
  signOut: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(Navigation);
